import React from "react";
import { motion } from "framer-motion";
import studyImg from "../../../images/Boy studying chinese language.png";
const IllustrationSection = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <motion.img
        src={studyImg}
        alt="Boy studying Chinese language"
        className="w-full max-w-md"
        // initial={{ opacity: 0, y: 20 }} // Starts slightly lower
        animate={{ opacity: 1, y: [20, -10, 20] }} // Moves up and down
        transition={{
          duration: 3,
          repeat: Infinity, // Loops forever
          // repeatType: "reverse", // Smooth back and forth motion
          // ease: "easeInOut", // Smooth transition
        }}
      />
    </div>
  );
};

export default IllustrationSection;
